/* Libraries */
import * as React from 'react';
import { useObserver } from 'mobx-react';

/* Components */
import { LoadingOverlay } from '~/src/components/PageLayout';
import { AiGemIcon } from '~/src/components/icons';
import { useStore } from '../hooks/useMst';
import { useEffect, useState } from 'react';

const Auth = ({ children }: { children: React.ReactElement }) => {
  const store = useStore();

  const [isSyncReload] = useState(
    () => localStorage.getItem('populate_sync_reload') === 'true',
  );

  useEffect(() => {
    store.initialize();
  }, [store]);

  const loadingTitle: React.ReactNode = isSyncReload ? (
    <span className="flex items-center justify-center gap-2">
      <AiGemIcon className="h-5 w-5 flex-shrink-0" />
      <span>Auto-filling document fields (2 of 2)...</span>
    </span>
  ) : (
    'Loading your data...'
  );

  const loadingSubtitle = isSyncReload ? '' : 'Please wait';

  return useObserver(() =>
    store.initializing ? (
      <LoadingOverlay
        title={loadingTitle}
        subtitle={loadingSubtitle}
        relative={false}
      />
    ) : (
      children
    ),
  );
};

export default Auth;
